module.exports = __webpack_public_path__ + "img/cock-signal-lights-no.6b0f7940.svg";